"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paletteJson = void 0;
const VerpackungModel_1 = require("./VerpackungModel");
exports.paletteJson = {
    EntityId: '1508954445089_947457',
    Id: 416230610,
    ArtNr: { DE: 'MAT0010092' },
    ArtNrExists: true,
    ArtNrGenerated: 'MAT0010092',
    Bezeichnung: { 'de-DE': 'Palette', 'en-GB': 'Pallet', 'en-US': 'Pallet' },
    Preis: { Countries: { DE: { EUR: 15.21 } } },
    Typ: VerpackungModel_1.VerpackungType.palette,
    Verpackungsmittel: 'Palette',
    Laenge: { Unit: 'mm', Value: 1050 },
    Breite: { Unit: 'mm', Value: 800 },
};
//# sourceMappingURL=paletteJson.js.map